import { SafeHtml } from "@angular/platform-browser";
import { Poster } from "./poster";
export class Article {
	constructor(
	  public id: number = 0,
	  public id_other: number = 0,
	  public timestamp: Date = new Date(),
	  public visible: boolean = true,  
	  public title: string = "",
	  public date: Date = new Date(),
	  public content: SafeHtml = "",	  
	  public author: string = "",
	  
	  public imageUrl: string = "",
	  public imageAltText: string = "",
	  public sitegroup: string = "",
	  public friendlyUrl: string = "",
	  public keywords: string = "",
	  public description: string = "",
	  public teaser: SafeHtml = "",
	  public titletag: string = "",
	  public posterUrl: string = "",
	  public posterAltText: string = "",
	  public posters: Array<Poster> = [],
	  public video: string = "",
	  public views: number = 0,
	  public approval_whitelist:boolean=false,
	 
	) {}
  
  
  }
  